import axios from 'axios';
const axiosInstance = axios.create();

const API_URL = process.env.REACT_APP_API_URL;

// Regiser 
export const register = async (userData) => {
  const response = await axios.post(`${API_URL}/auth/signup`, userData);
  return response;
};

export const login = async (credentials) => {
  const response = await axios.post(`${API_URL}/auth/signin`, credentials);
  return response;
};

export const logout = () => {
  localStorage.removeItem('token');
};

export const getCurrentUser = async (token) => {
    const response = await axios.get(`${API_URL}/auth/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
};

export const forgotPassword = async (email) => {
  const response = await axios.post(`${API_URL}/auth/forgot-password`, { email });
  return response.data;
};

export const resetPassword = async (token, code, newPassword) => {
  const response = await axios.post(`${API_URL}/auth/reset-password`, {
    token,
    code,
    newPassword
  });
  return response.data;
};

export const getUserProfile = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/users/profile`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const updateProfile = async (profileData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_URL}/users/profile`, profileData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const changePassword = async (passwordData, token) => {
  try {
    const response = await axios.post(`${API_URL}/auth/change-password`, passwordData, {
      headers: {
        Authorization: `Bearer ${token}`
      }

    });
    return response.data;
  } catch (error) {
    console.error("Change password failed:", error.response?.data || error.message);
    throw error;
  }
};

export const verifyEmail = async (token) => {
  const response = await axios.get(`${API_URL}/auth/verify-email`, {
    params: { token },
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  });
  return response.data;
};

// Resend Verification Email
export const resendVerificationEmail = async (email) => {
  const response = await axios.post(`${API_URL}/auth/resend-verification`, { email });
  return response.data;
};

export { axiosInstance };